import HomePage from "../pages/Home.vue";
import AppointmentsPage from "../pages/Appointments.vue";
import AppointmentStatus from "../pages/AppointmentStatus.vue";
import ChoseOption from "../pages/ChoseOption.vue";
import EnterPhone from "../pages/EnterPhone.vue";
import VisualFive from "../pages/VisualFive.vue";
import EnterName from "../pages/EnterName.vue";
import ScanQR from "../pages/ScanQR.vue";
import GoodToGo from "../pages/GoodToGo.vue";
import EnterEmail from "../pages/EnterEmail.vue";
import EnterTelephone from "../pages/EnterTelephone.vue";
import VisualEleven from "../pages/VisualEleven.vue";
import CommunicationType from "../pages/CommunicationType.vue";
import KioskLogin from "@/pages/KioskLogin.vue";
import KioskCreateAccount from "@/pages/KioskCreateAccount.vue";
import NoDoctor from "@/pages/NoDoctor.vue";
import AvailableDoctor from "@/pages/AvailableDoctor.vue";
import VerifyAppointment from "@/pages/VerifyAppointment.vue";
import EnterAppointmentID from "@/pages/EnterAppointmentID.vue";
import AboutHospital from "@/pages/AboutHospital.vue";
import HospitalSettings from "@/pages/HospitalSettings.vue";
import HospitalProfile from "@/pages/HospitalProfile.vue";
import DoctorAppointmentsList from "@/pages/DoctorAppointmentsList.vue";
import ViewDoctor from "@/pages/ViewDoctor.vue";
import QueueCounter from "@/pages/QueueCounter.vue";
import DoctorProfile from "@/pages/DoctorProfile.vue";
import CustomerSupport from "@/pages/CustomerSupport.vue";
import AppointmentApproval from "@/pages/AppointmentApproval.vue";
import UnauthorizedPage from "@/pages/Unauthorized.vue";
import DoctorBio from "@/pages/DoctorBio.vue";
import ManageAppointments from "@/pages/ManageAppointments.vue";
import KioskOtp from "@/pages/KioskOtp.vue";
import AddDoctorConversational from "@/pages/AddDoctorConversational.vue";
import TimeSlotsManagement from "@/pages/TimeSlotsManagement.vue";
import AppointmentTypesManagement from "@/pages/AppointmentTypesManagement.vue";
import HospitalGlobalSettings from "@/pages/HospitalGlobalSettings.vue";
import AppointmentDashboard from "@/pages/AppointmentDashboard.vue";
import SuperAdminSelection from "@/pages/SuperAdminSelection.vue";
import UserManagement from "@/pages/UserManagement.vue";

const DOMAIN_TITLE = process.env.VUE_APP_APP_NAME;

export const routes = [
  {
    path: "/login",
    name: "KioskLogin",
    component: KioskLogin,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Kiosk Login` },
  },
  {
    path: "/create-account",
    name: "KioskCreateAccount",
    component: KioskCreateAccount,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Kiosk Create Account` },
  },
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/appointments",
    name: "Appointments",
    component: AppointmentsPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Appointments` },
  },
  {
    path: "/appointment-status",
    name: "AppointmentStatus",
    component: AppointmentStatus,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Appointments` },
  },
  {
    path: "/chose-option",
    name: "ChoseOption",
    component: ChoseOption,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chose Option` },
  },
  {
    path: "/enter-phone",
    name: "EnterPhone",
    component: EnterPhone,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Enter Phone Number` },
  },
  {
    path: "/customer-support",
    name: "CustomerSupport",
    component: CustomerSupport,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Customer Support` },
  },
  {
    path: "/visual-5",
    name: "VisualFive",
    component: VisualFive,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/enter-name",
    name: "EnterName",
    component: EnterName,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/scanqr",
    name: "ScanQR",
    component: ScanQR,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Scan QR` },
  },
  {
    path: "/good-to-go",
    name: "GoodToGo",
    component: GoodToGo,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/no-doctor",
    name: "NoDoctor",
    component: NoDoctor,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | No Doctor Available` },
  },
  {
    path: "/available-doctor",
    name: "AvailableDoctor",
    component: AvailableDoctor,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Available Doctor` },
  },
  {
    path: "/verify-appointment",
    name: "VerifyAppointment",
    component: VerifyAppointment,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Verify Appointment` },
  },
  {
    path: "/enter-appointment-id",
    name: "EnterAppointmentID",
    component: EnterAppointmentID,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Enter Appointment ID` },
  },
  {
    path: "/about-hospital",
    name: "AboutHospital",
    component: AboutHospital,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | About Hospital` },
  },
  {
    path: "/hospital-settings",
    name: "HospitalSettings",
    component: HospitalSettings,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Hospital Settings`,
    },
  },
  {
    path: "/hospital-global-settings",
    name: "HospitalGlobalSettings",
    component: HospitalGlobalSettings,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Hospital Global Settings`,
    },
  },
  {
    path: "/hospital-profile",
    name: "HospitalProfile",
    component: HospitalProfile,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Hospital Profile`,
    },
  },
  {
    path: "/doctor-profile",
    name: "DoctorProfile",
    component: DoctorProfile,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Doctor Profile`,
    },
  },
  {
    path: "/add-doctor",
    name: "AddDoctorConversational",
    component: AddDoctorConversational,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Add New Doctor`,
    },
  },

  {
    path: "/queue-counter",
    name: "QueueCounter",
    component: QueueCounter,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Queue Counter`,
    },
  },

  {
    path: "/doctor-appointments-list",
    name: "DoctorAppointmentsList",
    component: DoctorAppointmentsList,
    meta: {
      isAuth: true,
      role: "hospital",
      title: `${DOMAIN_TITLE} | Doctor Appointments List`,
    },
  },
  {
    path: "/view-doctor/:id",
    name: "ViewDoctor",
    component: ViewDoctor,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | View Doctor` },
  },
  {
    path: "/enter-email",
    name: "EnterEmail",
    component: EnterEmail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/enter-telephone",
    name: "EnterTelephone",
    component: EnterTelephone,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/visual-11",
    name: "VisualEleven",
    component: VisualEleven,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/comunication-type",
    name: "CommunicationType",
    component: CommunicationType,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Home` },
  },
  {
    path: "/appointment-approval",
    name: "AppointmentApproval",
    component: AppointmentApproval,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Appointment Approval` },
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: UnauthorizedPage,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Unauthorized` },
  },
  {
    path: "/doctor-bio/:id",
    name: "DoctorBio",
    component: DoctorBio,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Doctor Bio` },
  },
  {
    path: "/manage-appointments",
    name: "ManageAppointments",
    component: ManageAppointments,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Manage Appointments` },
  },
  {
    path: "/kiosk-otp",
    name: "KioskOtp",
    component: KioskOtp,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | OTP Verification` },
  },
   {
    path: '/appointment-types',
    name: 'AppointmentTypes',
    component: AppointmentTypesManagement,
    meta: { requiresAuth: true, title: `${DOMAIN_TITLE} | Appointment Types` }
  },
  {
    path: '/timeslots',
    name: 'TimeslotsManagement',
    component: TimeSlotsManagement,
    meta: { requiresAuth: true, title: `${DOMAIN_TITLE} | Timeslots Management` }
  },
  {
    path: '/appointment-dashboard',
    name: 'AppointmentDashboard',
    component: AppointmentDashboard,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Appointment Dashboard` }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: UserManagement,
    meta: {
      isAuth: true,
      userManagementGuard: true,
      title: `${DOMAIN_TITLE} | User Management`
    }
  },
  {
    path: "/super-admin-selection",
    name: "SuperAdminSelection",
    component: SuperAdminSelection,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Super Admin Selection` },
  }
];
